import _defineProperty from "@babel/runtime/helpers/defineProperty";
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/prefer-function-type -- needed
export function singleton(Constructor) {
  var _class;

  return _class = class Singleton extends Constructor {
    // eslint-disable-line @typescript-eslint/prefer-readonly -- needed
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- needed
    constructor(...args) {
      if (Singleton.instance instanceof Singleton) {
        // eslint-disable-next-line no-constructor-return -- needed
        return Singleton.instance;
      } // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- needed


      super(...args);
      Singleton.instance = this; // eslint-disable-next-line no-constructor-return -- needed

      return this;
    }

  }, _defineProperty(_class, "instance", void 0), _class;
}
//# sourceMappingURL=singleton.js.map